class ApiIntegrationDetailRequestDatatable {
    constructor(tableId, apiIntegrationId) {
        this.datatable = this.initDatatable('#'+tableId,apiIntegrationId);
        this.initFilter();
        this.initResetFilter();
        this.initSearchActions();
        this.datatableActions(new URLSearchParams(window.location.search).get('organizationID'));
    }

    initSearchActions(){
        const thisClass = this;
        let timer;
        const input = document.getElementById('overview-filter-request-search');
        if(input){
            input.addEventListener('keyup', function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    thisClass.datatable.search(e.target.value).draw();
                }, 300);
            });
        }
    }

    initFilter(){
        const thisClass = this;
        $('#overview-filter-apply-button').on('click', function(e) {
            let numOfFilters        = 0;
            let responseCodeValue   = $('#overview-select-response-code').val();
            let methodValue         = $('#overview-select-method').val();
            let ipAddressValue      = $('#overview-ip-address').val();
            let dateRangeValue      = $('#overview-daterange-picker').val();
            let urlValue            = $('#overview-filter-url').val();

            if(typeof responseCodeValue === 'string' && responseCodeValue.length > 0) {
                thisClass.datatable.column(1).search(responseCodeValue);
                numOfFilters++;
            }
            if(typeof methodValue === 'string' && methodValue.length > 0) {
                thisClass.datatable.column(3).search(methodValue);
                numOfFilters++;
            }
            if(typeof ipAddressValue === 'string' && ipAddressValue.length > 0){
                thisClass.datatable.column(2).search(ipAddressValue);
                numOfFilters++;
            }

            if(typeof dateRangeValue === 'string' && dateRangeValue.length > 0) {
                thisClass.datatable.column(0).search(dateRangeValue);
                numOfFilters++;
            }

            if(typeof urlValue === 'string' && urlValue.length > 0) {
                thisClass.datatable.column(4).search(urlValue);
                numOfFilters++;
            }
            thisClass.datatable.draw();
            $('#communication-num-of-filter').text(numOfFilters);

        });
    }

    initResetFilter(){
        const thisClass = this;
        $('#overview-filter-reset-button').on('click', function(e) {
            $('#overview-select-response-code').val('').trigger('change');
            $('#overview-select-method').val('').trigger('change');
            $('#overview-ip-address').val('');
            $('#overview-daterange-picker').val('');
            $('#overview-filter-url').val('');

            $('#communication-num-of-filter').text(0);
            thisClass.datatable.columns().search('');
            thisClass.datatable.draw();
        });
    }
    initDatatable(el,apiIntegrationId) {
        let thisClass = this;
        const datatable = $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            ajax: {
                url: '?do=getApiIntegrationsRequests',
                type: 'POST',
                data: {
                    apiIntegrationId: apiIntegrationId
                }

            },
            language: {
                emptyTable: "For the selected filters, there are no records to display",
            },
            columnDefs: [
                { "width": "20%", "targets": 0 },
                { "width": "22%", "targets": 1 },
                { "width": "23%", "targets": 2 },
                { "width": "40%", "targets": 4 },
                {
                "defaultContent": "-",
                "targets": "_all"
            }],
            drawCallback: function(settings) {
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });


                $(document).on('mouseover','.get-ip-info',function(){
                    const clickedEl = $(this);
                    const ip = clickedEl.attr('data-value');
                    if(!clickedEl.attr('data-bs-toggle')) {
                        if (ip) {
                            $.ajax({
                                url: '/gateway-access-logs/?do=getIpInfo',
                                type: 'POST',
                                dataType: '',
                                data: {
                                    ip: ip,
                                    organizationID: new URLSearchParams(window.location.search).get('organizationID')
                                }
                            }).done(function (data) {
                                clickedEl.attr('data-bs-toggle', 'popover');
                                clickedEl.attr('data-bs-placement', 'top');
                                clickedEl.attr('data-bs-trigger', 'hover');
                                clickedEl.attr('data-bs-html', 'true');
                                clickedEl.attr('data-bs-content', `<div class='d-flex align-items-center'><div class='symbol symbol-30px me-3 border ga-border-primary-300 symbol-circle'><div class='symbol-label bg-light-primary border border-2 border-white overflow-hidden'>` + (data[`iso2`] ? `<img src='/media/goodaccess/country-flags/png100px/` + data[`iso2`].toLowerCase() + `.png' class='h-30px' alt='flag'>` : `<i class='fa-solid fa-question fs-1'></i>`) + `</div></div><div class='d-flex justify-content-start flex-column'>` + (data[`country`] ? `<div><span class='fw-bold text-white mb-1 fs-7'>` + data[`country`] + `</span></div>` : ``) + `<span class='fw-semibold d-block fs-8 text-white'>` + data['city'] + `</span></div></div>`);
                                clickedEl.popover('show');
                            });
                        }
                    }
                });
            },
            columns: [
                {
                    data: 'timestamp',
                    title: 'Date',
                    sortable: true,
                    render: function (data, type, row) {
                        return row.timestamp;
                    }
                },
                {
                    data: 'code',
                    title: 'Response Code',
                    sortable: true,
                    render: function (data, type, row) {
                        var badgeColor = 'success';
                        if(row.code >= 400) {
                            badgeColor = 'warning';
                        }
                        if(row.code >= 500) {
                            badgeColor = 'danger';
                        }
                        return '<span class="badge badge-'+badgeColor+' badge-circle w-10px h-10px me-2"></span>'+ row.code;
                    }
                },
                {
                    data: 'ip',
                    title: 'IP Address',
                    sortable: true,
                    render: function (data, type, row) {
                        return row.ip+'<i class="fa-regular fa-circle-question ms-1 fs-7 get-ip-info cursor-help" data-value="'+row.ip+'"></i>';
                    }
                },
                {
                    data: 'method',
                    title: 'Method',
                    sortable: true,
                    width: '25%',
                    render: function (data, type, row) {
                        return row.method;
                    }
                },
                {
                    data: 'url',
                    title: 'URL',
                    sortable: true,
                    render: function (data, type, row) {
                        return row.url;
                    }
                }
            ]
        }).on('init.dt', function () {
        });

        return datatable;
    }
    datatableActions(organizationID){
        $(document).on('mouseover','#gateway-level-logs-datatable .get-ip-info',function(){
            const clickedEl = $(this);
            if(!clickedEl.attr('data-bs-toggle')){
                const ip = clickedEl.attr('data-value');
                if(ip){
                    $.ajax({
                        url:  '/gateway-access-logs/?do=getIpInfo',
                        type: 'POST',
                        dataType: '',
                        data: { ip: ip, organizationID: organizationID}
                    }).done(function(data) {
                        clickedEl.attr('data-bs-toggle','popover');
                        clickedEl.attr('data-bs-placement','top');
                        clickedEl.attr('data-bs-trigger','hover');
                        clickedEl.attr('data-bs-html','true');
                        clickedEl.attr('data-bs-content',);
                        clickedEl.popover('show');
                    });
                }
            }
        });
    }
}
window.ApiIntegrationDetailRequestDatatable = ApiIntegrationDetailRequestDatatable;